module.exports = __webpack_public_path__ + "static/catering2.c0065152.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/catering2.png
// module id = 440
// module chunks = 35783957827783